export default __webpack_public_path__ + "static/media/donuts-taste-great.f19af117.md";